import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DePrivacy = _resolveComponent("DePrivacy")!
  const _component_MainContent = _resolveComponent("MainContent")!
  const _component_FrPrivacy = _resolveComponent("FrPrivacy")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.$i18n.locale === 'de')
      ? (_openBlock(), _createBlock(_component_MainContent, { key: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_DePrivacy)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.$i18n.locale === 'fr')
      ? (_openBlock(), _createBlock(_component_MainContent, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_FrPrivacy)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}